<template>
  <div>
    <v-alert
      v-model="alert"
      :border="notification.border"
      :type="notification.type"
      :dismissible="notification.dismissible"
    >
      {{ notification.message }}
    </v-alert>
  </div>
</template>

<script>
import { notificationsActions } from '@/store/helpers'
export default {
  name: 'NotificationBar',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeout: null,
      alert: true
    }
  },
  created() {
    if (!this.notification.dismissible) {
      const configTimeToHide =
        this.notification.timeToHide === 0
          ? process.env.VUE_APP_NOTIFICATION_HIDE_TIME_IN_MS
          : this.notification.timeToHide

      this.timeout = setTimeout(
        () => this.remove(this.notification),
        configTimeToHide
      )
    }
  },
  watch: {
    alert: function() {
      this.remove(this.notification)
    }
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  },
  methods: {
    ...notificationsActions
  }
}
</script>
